import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const Filter = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 18 17"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <path
        stroke="#475467"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
        d="M9.003 16c-1.676 0-1.683-1.672-1.683-4.5S1.5 6.69 1.5 3.584C1.5.961 3.825 1 9 1s7.5-.04 7.5 2.584c0 3.105-5.819 5.087-5.819 7.916 0 2.828-.002 4.5-1.678 4.5"
        clipRule="evenodd"
      />
      <rect
        width={5.833}
        height={0.833}
        x={6.5}
        y={4.333}
        fill="#475467"
        rx={0.417}
      />
    </svg>
  );
};
export default Filter;
